export default function brandLogo(){
    return(
        <img src="/logos/logo.png" alt="Logo diputación Jaén y Nattule" />
    )
}